export const environment = {
    apiKey: "AIzaSyCqqd7YZVGu9ESxxT01ur2yvDxKed_oc3g",
    authDomain: "personal-website-vhumeniuk.firebaseapp.com",
    databaseURL: "https://personal-website-vhumeniuk.firebaseio.com",
    projectId: "personal-website-vhumeniuk",
    storageBucket: "personal-website-vhumeniuk.appspot.com",
    messagingSenderId: "917867060956",
    appId: "1:917867060956:web:531385002f0278c7dd5e19",
    measurementId: "G-Z8GCXDQVVF"
}